import { map, set } from 'lodash'
import http from 'utils/http'
import TermDecorator from 'decorators/terms'

import { SET_TERMS, SET_PUBLISHED_TERM, RESET_TERM, SET_TERM, SET_TERM_ATTRIBUTE } from 'vx/mutations'

const initialTermState = () => {
  return {
    id: null,
    publisher: null,
    version: null,
    content: null,
    status: 1,
    published_at: null
  }
}

const state = {
  term: initialTermState(),
  published: initialTermState(),
  terms: []
}

const getters = {
  terms: state => map(state.terms, (term) => new TermDecorator(term)),
  term: state => new TermDecorator(state.term),
  published: state => new TermDecorator(state.published)
}

const actions = {
  /**
   * Get all terms.
   *
   * @param Function commit
   *
   * @return Promise
   */
  getTerms ({ commit }) {
    return http.get('terms').then((response) => {
      commit(SET_TERMS, response.data)

      return response
    })
  },

  /**
   * Get the published terms and conditions.
   *
   * @param Function commit
   *
   * @return Promise
   */
  getPublishedTerm ({ commit }) {
    return http.get(`terms/published`).then((response) => {
      commit(SET_PUBLISHED_TERM, response.data)

      return response
    })
  },

  acceptPublishedTerm (store) {
    return http.post(`terms/accept`)
  },

  /**
   * Get a term.
   *
   * @param Function commit
   * @param integer id
   *
   * @return Promise
   */
  getTerm ({ commit }, id) {
    return http.get(`terms/${id}`).then((response) => {
      commit(SET_TERM, response.data)

      return response
    })
  },

  /**
   * Store a term.
   *
   * @param Function commit
   * @param object payload
   *
   * @return Promise
   */
  storeTerm ({ commit }, payload) {
    return http.post('terms', payload).then((response) => {
      commit(SET_TERM, response.data)

      return response
    })
  },

  /**
   * Update a term.
   *
   * @param Function commit
   * @param integer id
   * @param object payload
   *
   * @return Promise
   */
  updateTerm ({ commit }, { id, payload }) {
    return http.put(`terms/${id}`, payload).then((response) => {
      commit(SET_TERM, response.data)

      return response
    })
  },

  /**
   * Publish a term.
   *
   * @param Function commit
   * @param integer id
   *
   * @return Promise
   */
  publishTerm ({ commit }, id) {
    return http.post(`terms/${id}/publish`).then((response) => {
      commit(SET_TERM, response.data)

      return response
    })
  },

  /**
   * Delete a term.
   *
   * @param Function commit
   * @param integer id
   *
   * @return Promise
   */
  deleteTerm ({ commit }, id) {
    return http.delete(`terms/${id}`).then((response) => {
      commit(RESET_TERM)

      return response
    })
  }
}

const mutations = {
  [SET_TERMS] (state, terms) {
    state.terms = terms
  },

  [SET_TERM] (state, term) {
    state.term = term
  },

  [SET_PUBLISHED_TERM] (state, term) {
    state.published = term
  },

  [RESET_TERM] (state) {
    state.term = initialTermState()
  },

  [SET_TERM_ATTRIBUTE] (state, { attribute, value }) {
    set(state.term, attribute, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/terms.js